<template>
  <div class="bg-light" style="margin-top: 80px;">
    <b-container>
      <b-alert class="row mt-2" variant="success" :show="showDismissibleAlert" dismissible>{{success_msg}}</b-alert>
      <b-col class="p-0">
        <nav area-label="breadcrumb">
          <ol class="breadcrumb bg-light pl-0" style="font-size: 14px;">
            <!-- <li class="breadcrumb-item"><a href="/" style="color: #007bff8a;">Home</a></li> -->
            <li class="breadcrumb-item"><a href='/recruit/client-job-dashboard' style="color: #007bff8a;">Dashboard</a></li>
            <li class="breadcrumb-item active text-dark" aria-current="page" v-if="job">{{job.job_designation}}</li>
          </ol>
        </nav>
      </b-col>
      <div class="d-flex justify-content-between mb-5 align-items-end">
        <p class="mb-0"><span style="color:#a5a5a5" v-if="job&&job.status">Job status:</span> {{getStatus(job.status)}}</p>
        <div class="d-flex justify-content-end">
          <a class="btn btn-outline-primary mr-3" href='/recruit/client-job-dashboard'>Go to dashboard</a>
          <!-- <a class="mr-3 btn btn-outline-primary">Add questionnaire</a> -->
          <a class="mr-1 btn btn-outline-primary" :href="'/recruit/edit/'+ id+'/draft/'+user_id">Edit</a>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-lg-12 jobDetails">
            <div class="jobHeader" v-if="job">
              <h1 v-if="job.job_designation">{{ job.job_designation }}</h1>
              <h2 v-if="job.company_name">
                <span class="jobIcon">
                  <img src="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/images/company.svg" alt="company name" title="company name" width="18"/>
                </span>{{ job.company_name }} &nbsp;&nbsp;
                <span class="jobIcon"><img src="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/images/location.svg" alt="location" title="location" width="22"/></span>
                <span v-for="(city, index) in job.cities" :key="index">{{ city}}<span v-if="job.cities.length != index + 1">,</span></span>
              </h2>

              <div class="salary">
                <span v-if="job.salary_flag && (job.salary_range_from || job.salary_range_to)" class="jobIcon"><img src="https://s3.ap-south-1.amazonaws.com/www.hireclap.com/Assets/images/money.svg" alt="salary" title="salary" width="30"/></span>
                <p v-if="job.salary_flag &&(job.salary_range_from || job.salary_range_to)">
                  <span> </span>
                  <span v-if="job.salary_range_from">Rs. {{ job.salary_range_from }}</span>
                  <span v-if="job.salary_range_from && job.salary_range_to">  - </span>
                  <span v-if="job.salary_range_to">Rs. {{ job.salary_range_to }}</span>
                </p>
                <p v-if="!job.salary_flag">
                  <span> Salary :</span> Not disclosed
                </p>
                <p v-if="!job.salary_flag"><span> Salary :</span> Not disclosed</p>
              </div>
              <button class="btn btn-primary" v-if="!applied && job.response_type == 1" v-b-tooltip.click title="It's a job preview page for review purpose only"> Apply now</button>
              <div v-if="job.response_type == 2 && !applied" class="howtoapply">
                <div v-if="job.title_description"><h6><strong>How to apply:</strong></h6></div>
                <div v-html="job.title_description"></div>
                <a class="btn btn-primary btn2" :href="job.link1" v-if="!applied && job.response_type == 2"  target="noopener">{{ job.label1 }}</a>
              </div>
              <button class="btn btn-primary" v-if="applied" disabled>Applied</button>
            </div>

            <div class="jobDescription" v-if="job">
              <div class="row subDetails">
                <div class="col-md-4">
                  <p v-if="jobrole">Job Role: <span>{{ jobrole.role }}</span></p>
                  <p v-if="c_job_type">Job Type: <span>{{ c_job_type }}</span></p>
                  <p v-if="courses.length">Education: <span v-for="course in courses" :key="course.course_id">{{ course.course_name }}</span></p>
                  <p v-if="cities.length">Location:
                    <span v-for="(city, itemObjKey) in cities" :key="city.city_id">{{ city.city_name }}<span v-if="cities.length != itemObjKey + 1">,</span></span>
                  </p>
                </div>
                <div class="col-md-4">
                  <p v-if="job.experience_from != null || job.experience_to != null">Experience:<span>{{getJobExp(job.experience_from, job.experience_to)}}</span></p>
                  <p v-if="job.hiring_process">Type: <span> {{ job.hiring_process }}</span></p>
                </div>
                <div class="col-md-4" v-if="job.last_date"><p>Last Date: <span> {{ job.last_date }}</span></p></div>
              </div>

              <div>
                <hr />
                <div class="row mb-1">
                  <div class="col-md-8" v-if="job.job_description"><h3>Job Description</h3></div>
                </div>
                <div class="description" v-html="job.job_description"></div>
                <!-- <ul style="color: #2625259c;">
                  <li v-if="job.job_designation">{{job.job_designation}}</li>
                  <li class="span01  mb-0" v-if="job.experience_from !=null || job.experience_to != null"><span style="color: #000;"> Experience :</span> <span>{{getJobExp(job.experience_from, job.experience_to)}}</span></li>
                  <li v-if="c_job_type">Job Type : {{c_job_type}}</li>
                  <li v-if="job.hiring_process">Interview Type : {{job.hiring_process}}</li>
                </ul> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <div class="alert alert-success error-message" id="alert-success" style="display: none;">Copied</div>
  </div>
</template>

<script>
export default ({
  name: "job_description",
  props:['id','type','user_id'],
  beforeMount(){
    this.getJobDetails();
    window.scrollTo(0,0);
  },
  data(){
    return{
      validate: new this.$valid(),
      jobDetails: null,
      job:null,
      courses:[],
      cities:[],
      jobrole:null,
      applied:false,
      job_type:[
          {value:1, text:'Full time'},
          {value:2, text:'Work from home'},
          {value:3, text:'Hybrid'},
          {value:4, text:'Part time'},
          {value:5, text:'Internship'},
          {value:6, text:'Apprenticeship'},
      ],
      exp:[
            { value: 1, text: "0 Month(Fresher)" },
            { value: 2, text: "06 Months" },
            { value: 3, text: "1 Year" },
            { value: 4, text: "2 year" },
            { value: 5, text: "3 year" },
            { value: 6, text: "4 year" },
            { value: 7, text: "5 year" },
            { value: 8, text: "6 year" },
            { value: 9, text: "6+ year" },
      ],
      c_job_type:null,
      showDismissibleAlert:false,
      success_msg:''
    }
  },
  methods:{
    getJobDetails(){
      new this.$apiAction().getJobDetails({id:this.id,type:this.type, user_id:this.user_id}).then(res => {
        this.jobDetails=res.data;
        this.job = res.data.jobs;
        if(!this.job.link1.match(/^https?:\/\//i)){
          this.job.link1 = 'https://' + this.job.link1;
        }
        this.getCourse();
        this.getCities();
        this.getJobrole();
        this.getJobType();
      });
    },
    getCourse(){
      new this.$apiAction().getCourse().then((data) => {
        data.courses.forEach(course => {
          this.jobDetails.courses.forEach(c => {
            if(course.course_id == c){
              this.courses.push(course)
            }
          })
        })
      })
    },
    getCities(){
        new this.$apiAction().getStates().then((data) => {
          this.jobDetails.cities.forEach(city => {
            data.states.forEach(state => {
              state.cities.forEach(c => {
                if(c.city_id == city){
                  this.cities.push(c)
                }
              })
            })
          })
        })
    },
    getJobrole(){
      new this.$apiAction().getJobrole().then(res => {
        res.jobroles.forEach(role => {
          if(role.role_id == this.jobDetails.jobs.job_role){
            this.jobrole = role
          }
        })
      })
    },
    getJobType(){
      this.job_type.forEach(type => {
        if(type.value == this.jobDetails.jobs.job_type){
          this.c_job_type = type.text;
        }
      })
    },
    newTab(url){
       if (!url.match(/^https?:\/\//i)) {
        url = 'https://' + url;
      }
      window.open(url, '_blank').focus();
    },
    getStatus(status) {
        switch(status) {
            case 0: return 'Pending'; 
            case 1: return 'Active'; 
            case 2: return 'Inactive'; 
            case 3: return 'Rejetced'; 
            case 4: return 'Deleted'; 
            case 5: return 'Archived'; 
            case 6: return 'on hold'; 
            default: break;
        }
    },
    convertTimestamp(data){
      var months = {'01':'Jan', '02':'Feb' , '03':'Mar' , '04':'Apr' , '05':'May' , '06':'June' , '07':'July' , '08':'Aug' , '09':'Sep' , '10':'Oct' , '11':'Nov' , '12':'Dec' , };
      var post_ms = data*1000
      var date_ob = new Date(post_ms)
      var year = date_ob.getFullYear();
      var month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
      var date = ("0" + date_ob.getDate()).slice(-2);
      var result = date+'th-'+months[month]+'-'+year;
      return result;
    },
    getJobExp(exp1, exp2){
      var display_exp = ''
      var experienceFrom = ''
      var experienceTo = ''
      
      if(exp1 == 0){
        experienceFrom="0";
      }else if(exp1 > 0 && exp1 < 12 ){	
        experienceFrom = exp1+" Months";
      }else{		
        experienceFrom=(exp1 / 12)+" Years";
      }		

      if(exp2 == 0 || exp2 == null){	
        experienceTo="0";		
      }else if(exp2 > 0 && exp2 < 12 ){		
        experienceTo= exp2+" Months";		
      }		
      else if(exp2 == 84){		
        experienceTo="6+";
      }else{		
        experienceTo=(exp2 / 12)+" Years";	
      }

      if(experienceFrom == "0" && experienceTo == "0"){		
        display_exp= "Fresher";
      }
      else if(exp2 == exp1){		
        display_exp = experienceTo;	
      }		
      else{		
        display_exp= experienceFrom+" to "+experienceTo;		
      }
      return display_exp;
    },
    copyToClipboard(job_id){
      var emp_token = this.$cookies.get("hire-employer").token;
      new this.$apiAction().getJobUrl(job_id,emp_token).then((res) => {
        if(res.status === true) {
          navigator.clipboard.writeText(process.env.VUE_APP_URL+'jobs/'+res.data.job_url);
          this.showDismissibleAlert = true;
          this.success_msg = 'Copied';
          setTimeout(() => {
            this.showDismissibleAlert = false;
          },5000);
        }
      });
    }
  }
})
</script>
<style scoped>
.jobDetails {
  background: white;
  padding: 0px;
  border-radius: 8px 8px 0px 0px !important;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
  border: none;
  overflow: hidden;
}
.jobHeader {
  background-image: linear-gradient(40deg, #3b63a4, #9a3b69);
  background-repeat: no-repeat;
  width: 100%;
  padding: 30px;
  color: white;
}
.jobHeader .btn-primary {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border-radius: 5px;
  color: white;
}
.jobHeader h1 {
  font-size: 22px;
  font-weight: bold;
  margin-right: 308px;
}
.jobHeader h2 {
  font-size: 17px;
  font-weight: normal;
  opacity: 0.5;
}
.jobHeader h3 {
  font-size: 14px;
  font-weight: normal;
  opacity: 1;
  padding: 0px;
  margin: 0px;
}
.jobDescription {
  padding: 30px;
  padding-bottom: 0px;
}
.jobDescription h3 {
  font-size: 20px;
  margin-bottom: 0px;
  font-weight: bold;
}
.salary {
  font-size: 20px;
  margin-top: 0px;
  padding-left: 43px;
  line-height: 29px;
}
.salary p {
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.jobIcon {
  width: 30px;
  display: inline-block;
  text-align: center;
  margin-left: -4px;
}
.salary .jobIcon img {
  margin-top: 4px;
  position: absolute;
  margin-left: -55px;
}
.subDetails p {
  color: #a5a5a5;
  margin-bottom: 5px;
}
.subDetails p span {
  color: #575757;
}

.relatedJobs {
  margin-top: 30px;
  background: white;
  padding: 30px;
  border-radius: 8px !important;
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 15%) !important;
  border: none;
  overflow: hidden;
}
.relatedJobs h4 {
  font-weight: bold;
  font-size: 20px;
}

.jobBox p {
  color: #000;
  margin: 0px;
  line-height: 33px;
}
.jobBox {
  padding: 25px;
}
.jobBox p.postDate {
  text-align: right;
  margin-top: -30px;
  color: #6a6a6a;
  font-size: 13px;
}
.jobIcon {
  width: 30px;
  display: inline-block;
  text-align: center;
  margin-left: -4px;
}
.jobBox img {
  margin-top: -4px;
}
.jobTitle {
  font-size: 16px;
  font-weight: bold;
  padding-right: 150px;
}
.jobTitle span.badge {
  position: absolute;
  margin-left: 5px;
}
.jobTitle a {
  color: #007bff;
}
.howtoapply {
  font-size: 16px;
  margin-top: 20px;
}
.howtoapply h6 {
  margin-bottom: 3px;
}
.jobtxt {
  margin-right: 40px;
}
.copy:hover{
  cursor: pointer;
  text-decoration: underline;
}

@media only screen and (max-width: 640px) {
  .jobHeader h1 {
    margin-right: 0px;
  }
  .subDetails .col-md-4 {
    padding: 0px 15px 0px 15px;
  }
  .jobtxt {
    margin-right: 40px;
  }
  .subDetails {
    padding: 15px 0px 15px 0px;
  }
  .subDetails p {
    margin: 0px 0px 10px 0px;
  }
  .salary {
    line-height: 15px;
  }
  .salary .jobIcon img {
    margin-top: -9px;
  }
  .jobHeader h2 {
    font-size: 15px;
  }
  .jobTitle {
    padding-right: 0px;
    line-height: 20px;
    font-size: 14px;
  }
  .myJobs {
    padding: 5px;
  }
  .jobBox {
    padding: 12px;
    transition: ease-out 0.1s;
    border-radius: 10px;
  }
  .jobBox:hover {
    background-color: #eef6ff;
  }
  .jobBox img {
    height: 18px;
  }
  .card {
    border-radius: 10px;
  }
  .jobBox p.postDate {
    text-align: left;
    margin-top: 0px;

    position: relative;
  }
  .jobBox p {
    padding-left: 28px;
    line-height: 22px;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 13px;
  }
  .jobIcon {
    margin-left: -34px;
  }
  .jobHeader,
  .jobDescription {
    padding: 20px;
  }
  .relatedJobs {
    padding: 5px;
    padding-bottom: 25px;
  }
  .relatedJobs .col-lg-6 {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .relatedJobs h4 {
    text-align: center;
    margin-top: 12px;
    margin-bottom: 20px;
  }
  .jobHeader .jobIcon {
    margin-left: -5px;
  }
  .jobHeader .btn-primary {
    position: fixed;
    border-radius: 0px;
    right: 0px;
    left: 0px;
    z-index: 50;
    bottom: 0px;
    top: inherit;
    width: 100%;
  }

  .howtoapply {
    background: #e3f6ff;
    color: #000;
    margin-top: 15px;
    margin-right: -30px;
    margin-bottom: -30px;
    margin-left: -30px;
    padding-left: 30px;
    padding-bottom: 10px;
    line-height: 20px;

    position: fixed;
    bottom: 30px;
    z-index: 50;
    left: 30px;
    width: 100%;
    right: 0;
    padding: 0px;
    padding-top: 10px;
    border-top: solid 1px #e7e7e7;
    font-size: 14px;
  }
  .howtoapply h6 {
    font-size: 15px;
    margin-bottom: 3px;
  }
  .howtoapply div {
    padding-left: 15px;
    padding-right: 15px;
  }
  .jobHeader a.btn2.btn-primary {
    position: relative;
    left: 0px;
    width: 100%;
    margin-top: 5px;
  }
  .breadcrumb .breadcrumb-item.active {
    width: 240px;
    height: 22px;
    overflow: hidden;
    background: -webkit-linear-gradient(223deg, #eee, #007bff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>